import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import ListItemText from '@mui/material/ListItemText';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Slide from '@mui/material/Slide';
import MyDialog from '../components/MyDialog';
import useForm from '../hooks/useForm';
import { useNavigate } from 'react-router-dom';
import WebService from '@util/webService';
import { FormControl, InputLabel, Input, FormHelperText, Alert, Grid, Container, Box, Typography } from '@mui/material';



const MaintenacePage = () => {
  const navigate = useNavigate()
 
  const fetchCodes = async() => {
    const url = '/code'
    const resp = await WebService.get(url)
    if(resp.repCode === 'ack') {
      navigate('/')
    }
  }

  React.useEffect(() => {
    fetchCodes()

  }, [])
  return (
    <Container >
      <Box>
        <Typography>
          시스템 작업 중입니다.
        </Typography>
        <Typography>
          서비스 이용에 불편을 드려서 죄송합니다.
        </Typography>
        
      </Box>
    </Container>
  );
}

export default MaintenacePage
